import { Middleware } from 'redux';
import { load, addNew, deleteById, updateTime, updateConsultationBy, resetConsultations } from './reducer';
import {
  setFutureSessions,
  addNewFutureSession,
  updateFutureSession,
  removeFutureSession,
  setPreviousSessions,
  updatePreviousSession,
  removePreviousSession,
} from './newList.reducer';

export const consultationsMiddleware: Middleware = (store) => (next) => (action) => {
  const result = next(action);

  switch (action.type) {
    case load.type:
      if (action.payload) {
        store.dispatch(setFutureSessions(action.payload));
        store.dispatch(setPreviousSessions(action.payload));
      }
      break;

    case addNew.type:
      if (action.payload) {
        store.dispatch(addNewFutureSession(action.payload));
      }
      break;

    case deleteById.type:
      store.dispatch(removeFutureSession(action.payload));
      store.dispatch(removePreviousSession(action.payload));
      break;

    case updateConsultationBy.type:
      const { field, value, data } = action.payload;
      if (field === 'id') {
        const sessionToUpdate = store.getState().consultations?.find((s: any) => s.id === value);
        if (sessionToUpdate) {
          const updatedSession = {
            ...sessionToUpdate,
            ...data,
          };
          store.dispatch(updateFutureSession({ id: value, session: updatedSession }));
          store.dispatch(updatePreviousSession({ id: value, session: updatedSession }));
        }
      }
      break;

    case updateTime.type:
      const { id, time } = action.payload;
      const session = store.getState().consultations?.find((s: any) => s.id === id);
      if (session) {
        const sessionToUpdate = {
          ...session,
          consultation_time: {
            _seconds: time,
            seconds: time,
            _nanoseconds: 0,
            nanoseconds: 0,
          },
        };
        store.dispatch(updateFutureSession({ id, session: sessionToUpdate }));
        store.dispatch(updatePreviousSession({ id, session: sessionToUpdate }));
      }
      break;

    case resetConsultations.type:
      store.dispatch(setFutureSessions([]));
      store.dispatch(setPreviousSessions([]));
      break;
  }

  return result;
};
